export const permissionsConfig = [
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.PRODUCTS_READ',
    resource: 'products',
    action: 'read',
    defaultValue: true,
    section: 'objects',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.PRODUCTS_CREATE',
    resource: 'products',
    action: 'create',
    defaultValue: false,
    section: 'objects',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.INGREDIENTS',
    resource: 'ingredients',
    action: 'read',
    defaultValue: true,
    section: 'objects',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.RECIPES',
    resource: 'recipes',
    action: 'read',
    defaultValue: true,
    section: 'objects',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.SUPPLIERS',
    resource: 'suppliers',
    action: 'read',
    defaultValue: true,
    section: 'objects',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.SUPPLIER_PRODUCTS',
    resource: 'supplier-products',
    action: 'read',
    defaultValue: true,
    section: 'objects',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.STORES',
    resource: 'stores',
    action: 'read',
    defaultValue: true,
    section: 'objects',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.INVENTORIES',
    resource: 'inventories',
    action: 'read',
    defaultValue: true,
    section: 'operations',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.ORDERS',
    resource: 'orders',
    action: 'read',
    defaultValue: true,
    section: 'operations',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.LOSSES',
    resource: 'losses',
    action: 'read',
    defaultValue: true,
    section: 'operations',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.TRANSFERS',
    resource: 'transfers',
    action: 'read',
    defaultValue: true,
    section: 'operations',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.RUSH_ORDERS',
    resource: 'rush-orders',
    action: 'read',
    defaultValue: true,
    section: 'operations',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.WEBHOOKS',
    resource: 'webhook-subscriptions',
    action: 'read',
    defaultValue: false,
    section: 'operations',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.MATERIAL_COST_AND_PAST_STOCKS',
    resource: 'analytics',
    action: 'read',
    defaultValue: true,
    section: 'analyses',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.PRODUCT_SALES',
    resource: 'product-sales',
    action: 'read',
    defaultValue: true,
    section: 'analyses',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.TRANSACTIONS',
    resource: 'transactions',
    action: 'read',
    defaultValue: false,
    section: 'analyses',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.EVENTS_CREATE',
    resource: 'events',
    action: 'create',
    defaultValue: false,
    section: 'analyses',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.CENTRAL_KITCHENS_PRODUCTS',
    resource: 'central-kitchens-products',
    action: 'read',
    defaultValue: false,
    section: 'central-kitchens',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.CENTRAL_KITCHENS_RECIPES',
    resource: 'central-kitchens-recipes',
    action: 'read',
    defaultValue: false,
    section: 'central-kitchens',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.CENTRAL_KITCHENS_PRODUCTION_PLANNING',
    resource: 'central-kitchens-production-planning',
    action: 'read',
    defaultValue: false,
    section: 'central-kitchens',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.CENTRAL_KITCHENS_PRODUCTION',
    resource: 'central-kitchens-production',
    action: 'read',
    defaultValue: false,
    section: 'central-kitchens',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.CENTRAL_KITCHENS_LOSSES',
    resource: 'central-kitchens-losses',
    action: 'read',
    defaultValue: false,
    section: 'central-kitchens',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.CENTRAL_KITCHENS_PAST_STOCKS',
    resource: 'central-kitchens-analytics',
    action: 'read',
    defaultValue: false,
    section: 'central-kitchens',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.PRODUCTION_METRICS',
    resource: 'production-analytics',
    action: 'read',
    defaultValue: false,
    section: 'mass-retail-production',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.PLANNING_RECOMMENDATIONS',
    resource: 'planning-recommendations',
    action: 'read',
    defaultValue: false,
    section: 'mass-retail-production',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.PRODUCTION_READ',
    resource: 'planning-operations',
    action: 'read',
    defaultValue: false,
    section: 'mass-retail-production',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.PRODUCTION_CREATE',
    resource: 'planning-operations',
    action: 'create',
    defaultValue: false,
    section: 'mass-retail-production',
  },
  {
    label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.PERMISSIONS.SALES',
    resource: 'production-metrics',
    action: 'read',
    defaultValue: false,
    section: 'mass-retail-production',
  },
];

export const sections = [
  { id: 'objects', label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.SECTIONS.OBJECTS' },
  { id: 'operations', label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.SECTIONS.OPERATIONS' },
  { id: 'analyses', label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.SECTIONS.ANALYSES' },
  { id: 'central-kitchens', label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.SECTIONS.CENTRAL_KITCHENS' },
  { id: 'mass-retail-production', label: 'ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.SECTIONS.PRODUCTION' },
];

export const API_KEY_FORM_MODE_ENUM = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
};

export const getKey = (permission) => `${permission.resource}_${permission.action}`;

export const getPermissions = (mode, selectedKey) =>
  mode === API_KEY_FORM_MODE_ENUM.UPDATE
    ? (() => {
        const uiToggleKeys = new Set(permissionsConfig.map((permission) => getKey(permission)));
        const selectedUiPermissions = selectedKey.resources
          .map((permission) => ({ ...permission, key: getKey(permission) }))
          .filter(({ key }) => uiToggleKeys.has(key))
          .map(({ key }) => [key, true]);

        return Object.fromEntries([
          ...permissionsConfig.map((permission) => [getKey(permission), false]),
          ...selectedUiPermissions,
        ]);
      })()
    : Object.fromEntries(
        permissionsConfig.map((permission) => [
          getKey(permission),
          permission.defaultValue ?? false,
        ]),
      );

export const buildResources = (permissions) =>
  permissionsConfig
    .filter((permission) => permissions[getKey(permission)])
    .map(({ resource, action }) => ({ resource, action }));
